import { testimonials, whyUs } from '../data/data';
import './Sections.css';

/* ─── WHY CHOOSE US ─── */
export function WhyUs() {
  const icons = {
    clock: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" />
      </svg>
    ),
    edit: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="2" /><path d="M8 9h8M8 13h5" />
      </svg>
    ),
    star: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
      </svg>
    ),
    map: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
        <circle cx="12" cy="9" r="2.5" />
      </svg>
    ),
  };

  return (
    <section id="why" className="why">
      <div className="container">
        <div className="why__head">
          <div className="eyebrow">Our Promise</div>
          <h2 className="section-title">Why travellers trust us</h2>
        </div>
        <div className="why__grid">
          {whyUs.map((w, i) => (
            <div key={i} className="why__card">
              <div className="why__icon">{icons[w.icon]}</div>
              <div className="why__title">{w.title}</div>
              <div className="why__desc">{w.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── TESTIMONIALS ─── */
export function Testimonials() {
  return (
    <section id="testimonials" className="testi">
      <div className="container">
        <div className="testi__head">
          <div className="eyebrow">Traveller Stories</div>
          <h2 className="section-title">Real journeys,<br />real memories</h2>
        </div>
        <div className="testi__grid">
          {testimonials.map(t => (
            <div key={t.id} className="testi__card">
              <div className="testi__stars">{'★'.repeat(t.stars)}</div>
              <div className="testi__quote">"{t.quote}"</div>
              <div className="testi__author-row">
                <div className="testi__avatar">{t.initials}</div>
                <div>
                  <div className="testi__name">{t.name}</div>
                  <div className="testi__loc">{t.loc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── CTA STRIP ─── */
export function CTAStrip({ onConsult }) {
  return (
    <section id="cta" className="cta-strip">
      <div className="cta-strip__grain" />
      <div className="container">
        <div className="cta-strip__inner">
          <div className="cta-strip__left">
            <div className="cta-strip__eyebrow">Start Your Journey</div>
            <h2 className="cta-strip__title">Ready for your next<br />dream destination?</h2>
            <p className="cta-strip__sub">Speak to a travel expert today — free 30-minute personalised consultation with no obligations.</p>
          </div>
          <div className="cta-strip__actions">
            <button className="btn-primary" onClick={onConsult}>Plan My Trip</button>
            <button className="btn-ghost-white" onClick={() => document.getElementById('tours')?.scrollIntoView({ behavior: 'smooth' })}>
              Browse Destinations
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── FOOTER ─── */
export function Footer({ onConsult, onOpenInfo }) {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <img src="https://ik.imagekit.io/nextdream/images/next-dream-holidays-logo?updatedAt=1777116828449" alt="Next Dream Holiday - Travel Agency in Gandhinagar & Ahmedabad" className="footer__logo-img" />
            </div>
            <p className="footer__tagline">Next Dream Holiday is your premier travel agent in Gandhinagar and Ahmedabad. We specialize in crafting unforgettable journeys, offering the best tour packages and custom holiday planning since 2022. Your dream, our expertise.</p>
            <div className="footer__socials">
              {/* Instagram */}
              <a href="https://www.instagram.com/nextdream_holidays?igsh=MW11cnlzemt2cjlrZw==" target="_blank" rel="noreferrer" className="footer__social">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" />
                </svg>
              </a>
              {/* Facebook */}
              <a href="https://www.facebook.com/share/1Qk2Xbat3r/" target="_blank" rel="noreferrer" className="footer__social">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              {/* Twitter/X 
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="footer__social">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4l16 16M4 20L20 4" />
                </svg>
              </a>
              YouTube
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="footer__social">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="5" width="20" height="14" rx="3" /><polygon points="10 9 15 12 10 15" fill="currentColor" stroke="none" />
                </svg>
              </a>
               */}
            </div>
          </div>

          <div>
            <div className="footer__col-title">Destinations</div>
            {/* {['Europe', 'South-East Asia', 'India', 'Africa & Safari', 'Latin America'].map(d => ( */}
            {['Europe', 'South-East Asia', 'India'].map(d => (
              <button key={d} className="footer__link" onClick={() => scrollTo('tours')}>{d}</button>
            ))}
          </div>
          <div>
            <div className="footer__col-title">Company</div>
            {/* {['About Us', 'Travel Blog', 'Careers', 'Press', 'Partners'].map(d => ( */}
            {['About Us'].map(d => (
              <button key={d} className="footer__link" onClick={() => ['About Us', 'Travel Blog'].includes(d) ? onOpenInfo(d) : {}}>{d}</button>
            ))}
          </div>
          <div>
            <div className="footer__col-title">Support</div>
            <button className="footer__link" onClick={() => onOpenInfo('Contact Us')}>Contact Us</button>
            {['FAQs', 'Booking Guide', 'Refund Policy', 'Travel Insurance'].map(d => (
              <button key={d} className="footer__link" onClick={() => onOpenInfo(d)}>{d}</button>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__copy">
            <div>© 2026 Next Dream Holidays. All rights reserved.</div>
            <div className="footer__seo-links" style={{ fontSize: '0.75rem', opacity: 0.6, marginTop: '1rem', lineHeight: '1.6' }}>
              Best Travel Agent in Gandhinagar | Best Tour Package in Gandhinagar | Custom Tour Packages in Gandhinagar | Travel Agency Gandhinagar | Best Travel Agent in Ahmedabad | Tour Operator in Ahmedabad | Holiday Packages from Ahmedabad | International Tour Packages from Gandhinagar | Domestic Tours Ahmedabad | Customized Holiday Planners Gujarat | Best Travel Company in Gandhinagar | Travel Agent Near Me Gandhinagar | Ahmedabad Travel Agency for International Tours
            </div>
          </div>
          <div className="footer__legal">
            {['Privacy Policy', 'Terms of Service', 'Cookie Preferences'].map(d => (
              <button key={d} className="footer__legal-link" onClick={() => onOpenInfo(d)}>{d}</button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
